import KibanaFilterMetadata from '../metadatas/osd-filter-metadata';
import { KibanaFilterType, ElasticFilterType } from '../filter-interfaces';
import LuceneFilterModel from '../models/lucene-filter-model';
import BaseFilterParser from './base-filter-parser';
/**
 * Elastic to Kibana 'LUCENE' filter parser
 */
export default class LuceneFilterParser extends BaseFilterParser {
    constructor() {
        super(KibanaFilterType.Query, ElasticFilterType.QueryString);
    }
    getMetadata(filter, negate = false, indexPattern) {
        let retVal = null;
        if (filter[this.elasticKey]) {
            const key = filter.query_string?.query ?? '';
            const value = 'query_string';
            retVal = new KibanaFilterMetadata(key, value, this.type, negate, indexPattern);
        }
        return retVal;
    }
    getFilter(metadata) {
        if (!this.assertType(metadata))
            return null;
        return new LuceneFilterModel(metadata);
    }
}
//# sourceMappingURL=lucene-filter-parser.js.map